import {
  message,
  PageHeader,
  Spin,
  Select,
  //Form as FormInitial,
  Row,
  Col,
  Tooltip,
  Space
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  InputItem,
  ButtonItem,
  ErrorItem,
  SelectInsumosItem,
  DynamicCardForm,
  TabbedDynamicTable,
} from "../../../../Components/Items";
import { PlusOutlined, DeleteOutlined, ContainerOutlined, FileExcelOutlined } from "@ant-design/icons";
import ElegirMarbetes from "../../Marbetes/ElegirMarbetes/ElegirMarbetes";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";
import ModalCargarExcelProductosAlCosto from "./ModalCargarExcelProductosAlCosto/ModalCargarExcelProductosAlCosto";

const { Option } = Select;

class AgregarOrdenProductosAlCosto extends Component {
  formRef = React.createRef();
  // Instancia y no state: se lee de forma sincrona dentro de onFinish, justo
  // despues del click. Mismo patron que "Agregar y Apartar" en Agregar Pedido.
  apartarSolicitado = false;
  state = {
    loading: false,
    objetoProyectos: null,
    todasProyectos: null,
    todasInsumos: [],
    objetoInsumos: null,
    modalAgregarCuentaContable: false,
    modalElegirMarbetes: false,
    modalElegirMarbetesMarbetes: [],
    modalElegirMarbetesInsumoId: null,
    modalElegirMarbetesProyectoId: null,
    modalCargarExcelVisible: false
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }
  onFinishFailed(e) {
    this.apartarSolicitado = false;
    ErrorItem(e);
  }
  onFinish(values) {
    const apartarDisponible = this.apartarSolicitado === true;
    this.apartarSolicitado = false;

    if (!values.insumos || values.insumos?.length === 0)
      return message.warning("Agregue insumos para poder agregar la orden");

    let insumos = values.insumos;
    if (apartarDisponible) {
      // Se aparta lo que haya: si el proyecto no alcanza para cubrir el
      // renglon completo, el apartado queda parcial y el resto se puede
      // apartar despues desde la orden.
      insumos = insumos.map((linea) => ({
        ...linea,
        apartar: typeof linea.cantidadProyecto === 'number'
          ? Math.max(0, Math.min(linea.cantidad || 0, linea.cantidadProyecto))
          : 0,
      }));
    }

    this.setState({ loading: true });
    axios
      .post(
        "productosAlCosto/agregarOrdenProductosAlCosto",
        {
          ...values,
          insumos,
          apartarDisponible,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            res.data.apartado
              ? "Se ha registrado la orden y se apartó el inventario disponible"
              : "Se ha registrado la orden"
          );
          if (apartarDisponible && !res.data.apartado) {
            message.warning("No se pudo apartar inventario; la orden quedó registrada sin apartado");
          }
          this.formRef.current.resetFields();
          this.atras();
        } else if (res.data.success === 1) {
          message.error(res.data.message ? res.data.message : "No se puede registrar la orden");
        } else {
          message.error("Hubo un error y la orden no se registro");
        }
      });
  }
  async onChangeInsumo(value, key, insumoEncontrado) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proyecto = await this.formRef.current.getFieldValue("proyectoId");
    this.setState({ loading: true });
    const insumoId = arrayValue[key].insumoId;
    let insumo
    if (insumoEncontrado) {
      insumo = insumoEncontrado;
      const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
      if (!yaExiste) {
        await this.setState(prev => ({
          todasInsumos: [...prev.todasInsumos, insumo]
        }));
      }
    } else {
      insumo = this.state.todasInsumos.find(
        (valueInsumos) => valueInsumos._id === insumoId
      );
    }
    this.setState({ loading: false });
    if (!insumo) return
    await axios
      .post(
        "inventarios/inventarioInsumoProyecto",
        {
          proyectoId: proyecto,
          insumoId: insumoId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        arrayValue[key].cantidadProyecto = res.data.cantidad;
      });
    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
  }
  // Carga masiva desde Excel: el modal ya resolvio los insumos y su disponible
  // en el proyecto (dos peticiones en total), asi que aqui solo se vacia el
  // resultado al formulario, sin volver a consultar inventario por renglon.
  cargarInsumosDesdeExcel = async (filasValidas) => {
    // Registrar de una sola vez en el catalogo local los insumos que no
    // estuvieran cacheados: el renglon lee de ahi la clave, la unidad y si
    // necesita lotes o marbetes.
    const yaExistentes = new Set(this.state.todasInsumos.map((i) => i._id.toString()));
    const insumosNuevos = [];
    filasValidas.forEach((f) => {
      if (!yaExistentes.has(f.insumo._id.toString())) {
        yaExistentes.add(f.insumo._id.toString());
        insumosNuevos.push(f.insumo);
      }
    });
    if (insumosNuevos.length > 0) {
      await new Promise((resolve) =>
        this.setState((prev) => ({ todasInsumos: [...prev.todasInsumos, ...insumosNuevos] }), resolve)
      );
    }

    this.formRef.current.setFieldsValue({
      insumos: filasValidas.map((f) => ({
        insumoId: f.insumo._id,
        cantidad: f.cantidad,
        cantidadProyecto: f.cantidadProyecto,
      })),
    });

    this.setState({ modalCargarExcelVisible: false });
    message.success(`${filasValidas.length} línea(s) cargada(s) desde Excel.`);
  };

  abrirElegirMarbetes(value, marbetes, insumoId, proyectoId) {
    if (proyectoId) {
      this.setState({
        modalElegirMarbetes: true,
        modalElegirMarbetesIndex: value,
        modalElegirMarbetesMarbetes: marbetes || [],
        modalElegirMarbetesInsumoId: insumoId,
        modalElegirMarbetesProyectoId: proyectoId
      })
    } else {
      message.warning('Elegir un proyecto para elegir marbetes')
    }
  }

  cerrarElegirMarbetes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirMarbetesIndex].marbetes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirMarbetes: false,
      modalElegirMarbetesIndex: null,
      modalElegirMarbetesMarbetes: null,
      modalElegirMarbetesInsumoId: null,
      modalElegirMarbetesProyectoId: null
    })
  }

  abrirElegirLotes(value, lotes, insumoId, proyectoId, cantidad) {
    const clienteId = this.formRef.current.getFieldValue('clienteId')
    if (proyectoId) {
      this.setState({
        modalElegirLotes: true,
        modalElegirLotesIndex: value,
        modalElegirLotesLotes: lotes || [],
        modalElegirLotesInsumoId: insumoId,
        modalElegirLotesProyectoId: proyectoId,
        modalElegirLotesClienteId: clienteId,
        modalElegirLotesCantidad: cantidad
      })
    } else {
      message.warning('Elegir un proyecto para elegir lotes')
    }
  }
  cerrarElegirLotes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirLotesIndex].lotes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirLotes: false,
      modalElegirLotesIndex: null,
      modalElegirLotesLotes: null,
      modalElegirLotesInsumoId: null,
      modalElegirLotesProyectoId: null,
      modalElegirLotesClienteId: null,
      modalElegirLotesCantidad: null
    })
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    const allTabs = [
      {
        key: 'insumos',
        label: 'Insumos',
        listName: 'insumos',
        columns: [
          { title: 'Clave', width: '6%' },
          { title: 'Insumo', width: '38%' },
          { title: 'Unidad', width: '6%' },
          { title: 'Cantidad Proyecto', width: '15%' },
          { title: 'Cantidad', width: '15%' },
          { title: 'Acción', width: '15%' },
        ],

        renderHeader: () => (
          <FormItem
            noStyle
            shouldUpdate={(prev, curr) => prev.proyectoId !== curr.proyectoId}
          >
            {({ getFieldValue }) => {
              const proyecto = getFieldValue("proyectoId");
              return (
                <ButtonItem
                  size="small"
                  icon={<FileExcelOutlined />}
                  onClick={
                    proyecto
                      ? () => this.setState({ modalCargarExcelVisible: true })
                      : () => message.info("Agregue el proyecto primero")
                  }
                >
                  Cargar Excel
                </ButtonItem>
              );
            }}
          </FormItem>
        ),

        renderRow: ({ key, name, restField, arrayKey, remove }) => (
          <FormItem key={key} noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const row = (getFieldValue('insumos') || [])[arrayKey];
              const lotes = row?.lotes || [];
              const insumo = this.state.todasInsumos?.find(i => i._id === row?.insumoId);
              const necesitaLotes = insumo?.lotesCaducidades;
              const cantidad = row?.cantidad || 0;
              const sumLotes = lotes.reduce((s, l) => s + (l.cantidadRequerida || 0), 0);
              const isRed = necesitaLotes && cantidad > 0 && sumLotes !== cantidad;
              return (
            <tr style={isRed ? { backgroundColor: '#ffccc7' } : {}}>
              <td className="td-border">
                <FormItem noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                    const insumoSeleccionado = this.state.todasInsumos?.find(
                      (insumo) => insumo._id.toString() === insumoId?.toString()
                    );
                    return (
                      <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                        {insumoSeleccionado?.clave || '-'}
                      </div>
                    );
                  }}
                </FormItem>
              </td>
              <td className="td-border">
                <FormItem
                  {...restField}
                  name={[name, "insumoId"]}
                  fieldKey={[arrayKey, "insumoId"]}
                  required
                  noStyle
                >
                  <SelectInsumosItem
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    sinBorde
                    autoFocus
                    ocultarCodigoYUnidad
                    dropdownMatchSelectWidth={600}
                    width="100%"
                    placeholder="Insumo"
                    tiposInsumos="inventariables"
                    onChange={(value, insumoEncontrado) =>
                      this.onChangeInsumo(value, arrayKey, insumoEncontrado)
                    }
                    insumoPreCargado={insumo}
                  />
                </FormItem>
              </td>
              <td className="td-border">
                <FormItem noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                    const insumoSeleccionado = this.state.todasInsumos?.find(
                      (insumo) => insumo._id.toString() === insumoId?.toString()
                    );
                    return (
                      <div style={{ fontSize: '14px', textAlign: 'center' }}>
                        {insumoSeleccionado?.unidad || '-'}
                      </div>
                    );
                  }}
                </FormItem>
              </td>

              <td className="td-border">
                <FormItem
                  {...restField}
                  name={[name, "cantidadProyecto"]}
                  fieldKey={[arrayKey, "cantidadProyecto"]}
                  number
                  noStyle
                  required
                  initialValue={undefined}
                >
                  <InputNumberItem sinBorde disabled />
                </FormItem>
              </td>
              <td className="td-border">
                <FormItem
                  noStyle
                  shouldUpdate={(prev, curr) =>
                    prev.insumos[arrayKey]?.cantidadProyecto !==
                    curr.insumos[arrayKey]?.cantidadProyecto
                  }
                >
                  {({ getFieldValue }) => {
                    const insumos = getFieldValue("insumos");
                    if (!insumos[arrayKey]) return
                    const cantidadProyecto =
                      insumos[arrayKey].cantidadProyecto;
                    let max = cantidadProyecto;
                    return (
                      <FormItem
                        {...restField}
                        name={[name, "cantidad"]}
                        fieldKey={[arrayKey, "cantidad"]}
                        number
                        noStyle
                        required
                        max={max}
                        type='number'
                        initialValue={undefined}
                      >
                        <InputNumberItem sinBorde />
                      </FormItem>
                    );
                  }}
                </FormItem>
              </td>
              <td className="td-border-sin-right">
                <Row className="acciones-container">
                  <Col span={24}>
                    <Space
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}
                      size={0}
                      className="acciones-container"
                    >
                      <Space size={0}>
                        <FormItem noStyle shouldUpdate>
                          {({ getFieldValue }) => {
                            const arrayValue = getFieldValue("insumos") || [];
                            const proyectoId = getFieldValue("proyectoId");

                            let buttons = [];
                            let mostrarMarbetes = false;
                            let mostrarLotes = false;
                            let insumoId;

                            if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                              const insumo = this.state.todasInsumos.find(
                                (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                              );

                              mostrarMarbetes = insumo?.marbetes;
                              mostrarLotes = insumo?.lotesCaducidades;
                              insumoId = insumo?._id;
                            }
                            if (mostrarMarbetes) {
                              buttons.push(
                                <ButtonItem
                                  type="primary"
                                  size="small"
                                  style={{ width: "80%", marginLeft: "10%" }}
                                  block
                                  onClick={() =>
                                    this.abrirElegirMarbetes(
                                      arrayKey,
                                      arrayValue[arrayKey].marbetes,
                                      insumoId,
                                      proyectoId
                                    )
                                  }
                                >
                                  Mar.
                                </ButtonItem>
                              );
                            } else if (mostrarLotes) {
                              buttons.push(
                                <Tooltip title={this.props.taxidermia ? "Animales" : "Lotes"} placement="top" overlayInnerStyle={{fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                  <ButtonItem
                                    type="primary"
                                    size='small'
                                    amarillo2
                                    icon={<ContainerOutlined />}
                                    onClick={() => {
                                      this.abrirElegirLotes(arrayKey, arrayValue[arrayKey].lotes, insumoId, proyectoId, arrayValue[arrayKey].cantidad)
                                    }}
                                  >
                                  </ButtonItem>
                                </Tooltip>
                              );
                            }
                            return buttons;
                          }}
                        </FormItem>
                      </Space>
                      <Tooltip title="Eliminar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                        <ButtonItem rojo2 icon={<DeleteOutlined />} onClick={() => remove(name)} size="small" lessTime />
                      </Tooltip>
                    </Space>
                  </Col>
                </Row>
              </td>
            </tr>
              );
            }}
          </FormItem>
        ),

        renderFooter: ({ add, fields }) => (
          <FormItem
            noStyle
            shouldUpdate={(prev, curr) =>
              prev.proyectoId !== curr.proyectoId
            }
          >
            {({ getFieldValue }) => {
              const proyecto = getFieldValue("proyectoId");
              return (
                <FormItem noStyle>
                  <div style={{ marginBottom: 6, marginTop: 6 }}>
                    <ButtonItem
                      type="dashed"
                      hotkey="alt+a"
                      cyan
                      block
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        justifySelf: fields.length > 0 ? "left" : null,
                        width: fields.length > 0 ? "auto" : null,
                      }}
                      onClick={
                          proyecto
                          ? () => add()
                          : () =>
                            message.info(
                              "Agregue el proyecto primero"
                            )
                      }
                      icon={<PlusOutlined />}
                    >
                      Agregar Campo
                    </ButtonItem>
                  </div>
                </FormItem>
              );
            }}
          </FormItem>
        ),
      },
    ];
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Agregar Orden - Productos al costo"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="productosAlCosto"
              layout
              bottom={
                <div className="general-form-action-buttons">
                  <Space>
                    <FormItem noStyle shouldUpdate>
                      {({ getFieldValue }) => {
                        const insumosActuales = getFieldValue('insumos') || [];
                        const hayDisponibleParaApartar = insumosActuales.some(
                          (v) => v && typeof v.cantidadProyecto === 'number' && v.cantidadProyecto > 0
                        );
                        if (!hayDisponibleParaApartar) return null;
                        return (
                          <ButtonItem
                            type="primary"
                            htmlType="submit"
                            blanco
                            onClick={() => { this.apartarSolicitado = true; }}
                          >
                            Agregar y Apartar
                          </ButtonItem>
                        );
                      }}
                    </FormItem>
                    <ButtonItem
                      type="primary"
                      htmlType="submit"
                      hotkey="shift+a"
                      cyanB
                    >
                      Agregar
                    </ButtonItem>
                  </Space>
                </div>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed.bind(this)}
            >
          <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
            <Col xs={24} lg={24} xl={24}>
              <DynamicCardForm
                title="DATOS GENERALES"
                style={{ margin: 0, height: '100%' }}
              >
                <Row gutter={[12, 12]}>
                  <Col xs={24} lg={12}>
                    <FormItem shouldUpdate noStyle>
                      {({ getFieldValue }) => {
                        const insumos = getFieldValue('insumos')
                        const disabled = insumos?.length > 0
                        return (
                          <FormItem label="Proyecto" name="proyectoId" margin required>
                            <SelectItem placeholder="Proyecto" disabled={disabled}>
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                        )
                      }}
                    </FormItem>
                  </Col>
                  <Col xs={24} lg={12}>
                    <FormItem
                      name="referencia"
                      label="Referencia"
                      margin
                      pattern
                    >
                      <InputItem placeholder="Referencia" />
                    </FormItem>
                  </Col>  
                </Row>
              </DynamicCardForm>
            </Col>
          </Row>
               <div style={{ marginTop: 40 }}>
                <TabbedDynamicTable
                  formInstance={this.formRef}
                  defaultActiveKey="insumos"
                  isMobile={isMobile}
                  tabs={allTabs}
                />
               </div>
            </Form>
          </Spin>
        </div>
        <ElegirMarbetes
          visible={this.state.modalElegirMarbetes}
          cerrarElegirMarbetes={this.cerrarElegirMarbetes.bind(this)}
          marbetes={this.state.modalElegirMarbetesMarbetes}
          insumoId={this.state.modalElegirMarbetesInsumoId}
          proyectoId={this.state.modalElegirMarbetesProyectoId}
        />
        <ElegirLotes
          visible={this.state.modalElegirLotes}
          cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
          lotes={this.state.modalElegirLotesLotes}
          insumoId={this.state.modalElegirLotesInsumoId}
          proyectoId={this.state.modalElegirLotesProyectoId}
          clienteId={this.state.modalElegirLotesClienteId}
          cantidad={this.state.modalElegirLotesCantidad}
        />
        <ModalCargarExcelProductosAlCosto
          visible={this.state.modalCargarExcelVisible}
          onCancel={() => this.setState({ modalCargarExcelVisible: false })}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          proyectoId={this.formRef.current?.getFieldValue("proyectoId")}
          onConfirmar={this.cargarInsumosDesdeExcel}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(AgregarOrdenProductosAlCosto);
